module.exports = __webpack_public_path__ + "static/WEDDING E&M-140-8aa9b40b18ea1171fa6df6c171b9dc48.jpg";